jQuery(document).ready(function () {
  setTimeout(function () {
    splitInvestorString();
    availableInformation();
  }, 1000);
});

function splitInvestorString() {
  //fix the action price
  jQuery.each(['ino_last-price_0', 'ino_change-dollar_0'], function (i, l) {

    var obj = jQuery('#' + l);
    var p = obj.html();

    if (typeof p !== 'undefined') {
      p = p.replace("(", "");
      p = p.replace(")", "");
      var lang = jQuery(this).parents('.stock-share-info').data('lang');

      if (jQuery(obj).hasClass("inoIrNegativeValue")) {

        p = "-" + p;

      }

      if (p.match(/(\d|\d\d|\d\d\d)(,|\.)(\d+)\s+\$/)) {
        //alert(p);
        var e = p.replace(/(\d|\d\d|\d\d\d)(,|\.)(\d+)\s+\$/, '$1');
        var s = p.replace(/(\d|\d\d|\d\d\d)(,|\.)(\d+)\s+\$/, '$2');
        var c = p.replace(/(\d|\d\d|\d\d\d)(,|\.)(\d+)\s+\$/, '$3').slice(0, 2);

        if (jQuery(obj).hasClass("inoIrNegativeValue")) {
          var t = p;
        } else {
          var t = e + s + c + ' $';
          //alert('e' + e);
          //alert('s' + s);
          //alert('c' + c);
        }

        obj.html(t);
      }
    }
  });

  //fix the content
  var h = jQuery('#ino_delayed-info').html();

  if (typeof h !== 'undefined') {
    //add br
    //h = h.replace(/(\s+)(on|le\s+)/g, "<br />$2");

    //fix date format
    h = h.replace(/(on|le\s+)(.*)-(\d+)-(\d+)\.$/, "$1 $2 $3, 20$4.");
    jQuery('#ino_delayed-info').html(h);
  }
}

function availableInformation() {
  jQuery('.stock-share-info').each(function(){
    jQuery(this).find('.ssi__values').removeClass('loading').addClass('active');
  });
}
